import script from "./LandingPageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingPageView.vue?vue&type=script&lang=ts&setup=true"

import "./LandingPageView.vue?vue&type=style&index=0&id=60fdfaa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fdfaa4"]])

export default __exports__